var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isAuthenticated
    ? _c(
        "header",
        { staticClass: "smile-header" },
        [
          _c(
            "div",
            {
              staticClass: "smile-header-container smile-header-container-menu"
            },
            [
              _c("div", { staticClass: "smile-header-logo-page" }, [
                _c("span", { staticClass: "smile-header-title" }, [
                  _vm._v(_vm._s(_vm.headerTitle()))
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "smile-header-logo" },
            [
              _c(
                "router-link",
                {
                  staticClass: "smile-header-logo-link",
                  attrs: { to: { path: "/" } }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/smile-logo-header-one-line.svg"),
                      alt: "SmileKiosk"
                    }
                  })
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "nav",
            { staticClass: "smile-header-nav-desktop" },
            [
              _c("router-link", { attrs: { to: { path: "/" } } }, [
                _vm._v("\n      Αρχική\n    ")
              ]),
              _vm._v(" "),
              _c("router-link", { attrs: { to: { path: "/loyalty-card" } } }, [
                _vm._v("\n      Κάρτα\n    ")
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  class: _vm.exactActiveClass("invoices"),
                  attrs: { to: { path: "/invoices" } }
                },
                [_vm._v("\n      Ιστορικό Αγορών\n    ")]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  class: _vm.exactActiveClass("points"),
                  attrs: { to: { path: "/points" } }
                },
                [_vm._v("\n      Σημεία\n    ")]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  class: _vm.exactActiveClass("account"),
                  attrs: { to: { path: "/account" } }
                },
                [_vm._v("\n      Προφίλ\n    ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("router-link", {
            attrs: { to: { path: "/loyalty-card" }, custom: "" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(ref) {
                    var navigate = ref.navigate
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "smile-header-container smile-header-container-coins",
                          attrs: { role: "link" },
                          on: {
                            click: navigate,
                            keypress: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return navigate.apply(null, arguments)
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "header-coins-text" }, [
                            _c(
                              "span",
                              { staticClass: "header-coins-text-wrapper" },
                              [
                                _c("b", [_vm._v(_vm._s(_vm.goldCoins))]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "header-smiles-text" },
                                  [_vm._v("smiles")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("img", {
                              attrs: {
                                src: require("@/assets/images/smile-coin-transparent.svg"),
                                alt: "Smile Coin"
                              }
                            })
                          ])
                        ]
                      )
                    ]
                  }
                }
              ],
              null,
              false,
              3983907860
            )
          })
        ],
        1
      )
    : _c("header", { staticClass: "smile-header-login-page" }, [
        _c(
          "div",
          { staticClass: "smile-header-logo" },
          [
            _c("router-link", { attrs: { to: { path: "/" } } }, [
              _c("img", {
                attrs: {
                  src: require("@/assets/images/smile-logo-header-one-line-aunauthenticated.svg"),
                  alt: "SmileKiosk"
                }
              })
            ])
          ],
          1
        )
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bb50a5e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb50a5e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","b-avatar":"src","b-img":"src","b-img-lazy":["src","blank-src"],"b-card":"img-src","b-card-img":"src","b-card-img-lazy":["src","blank-src"],"b-carousel-slide":"img-src","b-embed":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeader.vue
// module id = null
// module chunks = 